// 导入Vue路由相关工具
import { createRouter, createWebHistory } from 'vue-router'

// 后台公共布局（侧边栏+顶部）不懒加载，因为它是后台所有页面的基础容器
import adminBackendCom from '../components/adminBackendCom/index.vue'

// 路由配置：路径 ↔ 页面 映射（核心！）
const routes = [
  // 首页（默认路径，打开项目先显示首页）
  {
    path: '/',
    name: 'HomeWeb',
    component: () => import('../views/HomeWeb.vue')
  },
  // 前端新闻列表路径
  {
    path: '/TopNews',
    name: 'TopNews',
    component: () => import('../views/cornflowerWeb/topNews.vue')
  },
  // 前端新闻详情路径
  {
    path: '/TopContent/:id',
    name: 'TopContent',
    component: () => import('../views/cornflowerWeb/topContent.vue')
  },
  // 购物首页
  {
    path: '/ShopList',
    name: 'ShopList',
    component: () => import('../views/cornflowerWeb/shopList.vue')
  },
  // 前端用户登录
  {
    path: '/UserLogin',
    name: 'UserLogin',
    component: () => import('../views/cornflowerWeb/userLogin.vue')
  },
  // 前端用户注册
  {
    path: '/UserJoin',
    name: 'UserJoin',
    component: () => import('../views/cornflowerWeb/userJoin.vue')
  },
  // 联系我们
  {
    path: '/ContactUs',
    name: 'ContactUs',
    component: () => import('../views/cornflowerWeb/contactUs.vue')
  },
  // 产品详情
  {
    path: '/ProductContent',
    name: 'ProductContent',
    component: () => import('../views/cornflowerWeb/productContent.vue')
  },
  // 前端用户后台
  {
    path: '/UserBackend',
    name: 'UserBackend',
    component: () => import('../views/cornflowerWeb/userBackend.vue')
  },
  // 退换货须知
  {
    path: '/Returns',
    name: 'Returns',
    component: () => import('../views/cornflowerWeb/returns.vue')
  },
  // 隐私保护
  {
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('../views/cornflowerWeb/PrivacyPolicy.vue')
  },
  // 售后服务
  {
    path: '/AfterSalesService',
    name: 'AfterSalesService',
    component: () => import('../views/cornflowerWeb/AfterSalesService.vue')
  },
  // 发货须知
  {
    path: '/ShippingPolicy',
    name: 'ShippingPolicy',
    component: () => import('../views/cornflowerWeb/ShippingPolicy.vue')
  },
  // 收藏列表
  {
    path: '/profile/wishlist',
    name: 'Wishlist',
    component: () => import('../views/cornflowerWeb/profile/wishlist.vue')
  },
  // 购物车
  {
    path: '/profile/cart',
    name: 'ShoppingCart',
    component: () => import('../views/cornflowerWeb/profile/shoppingCart.vue')
  },
  // 订单列表
  {
    path: '/profile/orders',
    name: 'Orders',
    component: () => import('../views/cornflowerWeb/profile/orderList.vue')
  },
  // 用户信息
  {
    path: '/profile/info',
    name: 'UserProfile',
    component: () => import('../views/cornflowerWeb/profile/userProfile.vue')
  },
  // Payment Methods
  {
    path: '/profile/payment',
    name: 'Payment',
    component: () => import('../views/cornflowerWeb/userBackend.vue')
  },
  // My Reviews
  {
    path: '/profile/reviews',
    name: 'Reviews',
    component: () => import('../views/cornflowerWeb/userBackend.vue')
  },
  // My Profile
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/cornflowerWeb/userBackend.vue')
  },
  // Addresses
  {
    path: '/profile/addresses',
    name: 'Addresses',
    component: () => import('../views/cornflowerWeb/userBackend.vue')
  },
  // Logout
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/cornflowerWeb/profile/logout.vue')
  },
  // 利海商圈动态和介绍页面
  {
    path: '/LihaibcContent',
    name: 'LihaibcContent',
    component: () => import('../views/cornflowerWeb/lihaibcContent.vue')
  },
  // 利海商圈动态详情页面
  {
    path: '/LihaibcNews/:id',
    name: 'LihaibcNews',
    component: () => import('../views/cornflowerWeb/lihaibcNews.vue')
  },
  // 进销商、专门店加盟
  {
    path: '/JoinDealer',
    name: 'JoinDealer',
    component: () => import('../views/cornflowerWeb/JoinDealer.vue')
  },
  // 定制合作
  {
    path: '/JoinCustom',
    name: 'JoinCustom',
    component: () => import('../views/cornflowerWeb/JoinCustom.vue')
  },
  // 平台合作
  {
    path: '/PlatformJoin',
    name: 'PlatformJoin',
    component: () => import('../views/cornflowerWeb/PlatformJoin.vue')
  },
  // 后台登录页面
  {
    path: '/AdminLogin',
    name: 'AdminLogin',
    component: () => import('../views/adminBackend/AdminLogin.vue')
  },
  // --- 后台系统：需要布局包裹 ---
  {
    path: '/', // 后台根路径
    component: adminBackendCom, // 关键：加上布局
    redirect: '/HomeBack', // 重定向到后台首页
    children: [
      // 后台首页
      {
        path: '/HomeBack',
        name: 'HomeBack',
        component: () => import('../views/adminBackend/HomeBack.vue'),
        meta: { title: '后台首页' }
      },
      // 进销存看板
      {
        path: '/DashboardMx',
        name: 'DashboardMx',
        component: () => import('../views/adminBackend/Dashboard/DashboardMx.vue'),
        meta: { title: '进销存看板' }
      },
      // 产品管理
      {
        path: '/ProductSystem/ProductList',
        name: 'ProductList',
        component: () => import('../views/adminBackend/ProductSystem/ProductList.vue'),
        meta: { title: '产品列表' }
      },
      {
        path: '/ProductSystem/ProductGallery',
        name: 'ProductGallery',
        component: () => import('../views/adminBackend/ProductSystem/ProductGallery.vue'),
        meta: { title: '产品图库' }
      },
      // 仓库管理
      {
        path: '/InventorySystem/WarehouseList',
        name: 'WarehouseList',
        component: () => import('../views/adminBackend/InventorySystem/WarehouseList.vue'),
        meta: { title: '仓库管理' }
      },
      {
        path: '/InventorySystem/PurchaseList',
        name: 'PurchaseList',
        component: () => import('../views/adminBackend/InventorySystem/PurchaseList.vue'),
        meta: { title: '产品采购' }
      },
      {
        path: '/InventorySystem/StockInList',
        name: 'StockInList',
        component: () => import('../views/adminBackend/InventorySystem/StockInList.vue'),
        meta: { title: '产品入库' }
      },
      {
        path: '/InventorySystem/StockOutList',
        name: 'StockOutList',
        component: () => import('../views/adminBackend/InventorySystem/StockOutList.vue'),
        meta: { title: '产品出库' }
      },
      {
        path: '/InventorySystem/ChannelPurchaseList',
        name: 'ChannelPurchaseList',
        component: () => import('../views/adminBackend/InventorySystem/ChannelPurchaseList.vue'),
        meta: { title: '渠道采购' }
      },
      // 销售管理
      {
        path: '/SaleSystem/SaleList',
        name: 'SaleList',
        component: () => import('../views/adminBackend/SaleSystem/SaleList.vue'),
        meta: { title: '销售列表' }
      },
      {
        path: '/SaleSystem/SaleChanceList',
        name: 'SaleChanceList',
        component: () => import('../views/adminBackend/SaleSystem/SaleChanceList.vue'),
        meta: { title: '销售机会' }
      },
      {
        path: '/SaleSystem/SaleChanceFollowList',
        name: 'SaleChanceFollowList',
        component: () => import('../views/adminBackend/SaleSystem/SaleChanceFollowList.vue'),
        meta: { title: '跟进记录' }
      },
      {
        path: '/SaleSystem/UserDataList',
        name: 'UserDataList',
        component: () => import('../views/adminBackend/SaleSystem/UserDataList.vue'),
        meta: { title: '电商用户' }
      },
      {
        path: '/SaleSystem/ContactMessageList',
        name: 'ContactMessageList',
        component: () => import('../views/adminBackend/SaleSystem/ContactMessageList.vue'),
        meta: { title: '用户留言' }
      },
      {
        path: '/SaleSystem/OrderList',
        name: 'OrderList',
        component: () => import('../views/adminBackend/SaleSystem/OrderList.vue'),
        meta: { title: '电商订单' }
      },
      // 用户管理
      {
        path: '/usersSystem/UserList',
        name: 'UserList',
        component: () => import('../views/adminBackend/usersSystem/UserList.vue'),
        meta: { title: '用户列表' }
      },
      {
        path: '/usersSystem/RoleList',
        name: 'RoleList',
        component: () => import('../views/adminBackend/usersSystem/RoleList.vue'),
        meta: { title: '权限列表' }
      },
      // 系统管理
      {
        path: '/adminSystem/LogList',
        name: 'LogList',
        component: () => import('../views/adminBackend/adminSystem/LogList.vue'),
        meta: { title: '销售日志' }
      },
      {
        path: '/adminSystem/PageViewStats',
        name: 'PageViewStats',
        component: () => import('../views/adminBackend/adminSystem/PageViewStats.vue'),
        meta: { title: '页面浏览统计' }
      },
      {
        path: '/adminSystem/SystemUpdateLog',
        name: 'SystemUpdateLog',
        component: () => import('../views/adminBackend/adminSystem/SystemUpdateLog.vue'),
        meta: { title: '系统更新日志' }
      },
      {
        path: '/adminSystem/FrontendUpdateLog',
        name: 'FrontendUpdateLog',
        component: () => import('../views/adminBackend/adminSystem/FrontendUpdateLog.vue'),
        meta: { title: '界面更新日志' }
      },
      // 企业培训
      {
        path: '/CompanyTrainSystem/TrainCompanyList',
        name: 'TrainCompanyList',
        component: () => import('../views/adminBackend/CompanyTrainSystem/TrainCompanyList.vue'),
        meta: { title: '企业培训' }
      },
      {
        path: '/CompanyTrainSystem/TrainCourseList',
        name: 'TrainCourseList',
        component: () => import('../views/adminBackend/CompanyTrainSystem/TrainCourseList.vue'),
        meta: { title: '培训管理' }
      },
      // 供应链管理
      {
        path: '/SupplyChainSystem/SupplierPurchaseStats',
        name: 'SupplierPurchaseStats',
        component: () => import('../views/adminBackend/SupplyChainSystem/SupplierPurchaseStats.vue'),
        meta: { title: '供应商采购汇总' }
      },
      {
        path: '/SupplyChainSystem/SupplierList',
        name: 'SupplierList',
        component: () => import('../views/adminBackend/SupplyChainSystem/SupplierList.vue'),
        meta: { title: '供应商列表' }
      },
      {
        path: '/SupplyChainSystem/RawMaterialList',
        name: 'RawMaterialList',
        component: () => import('../views/adminBackend/SupplyChainSystem/RawMaterialList.vue'),
        meta: { title: '原材料列表' }
      },
      {
        path: '/SupplyChainSystem/RawMaterialPurchaseList',
        name: 'RawMaterialPurchaseList',
        component: () => import('../views/adminBackend/SupplyChainSystem/RawMaterialPurchaseList.vue'),
        meta: { title: '原材料采购' }
      },
      {
        path: '/SupplyChainSystem/RawMaterialInList',
        name: 'RawMaterialInList',
        component: () => import('../views/adminBackend/SupplyChainSystem/RawMaterialInList.vue'),
        meta: { title: '原材料入库' }
      },
      {
        path: '/SupplyChainSystem/RawMaterialOutList',
        name: 'RawMaterialOutList',
        component: () => import('../views/adminBackend/SupplyChainSystem/RawMaterialOutList.vue'),
        meta: { title: '原材料出库' }
      },
      // 物料管理
      {
        path: '/MaterialSystem/MaterialList',
        name: 'MaterialList',
        component: () => import('../views/adminBackend/SupplyChainSystem/MaterialSystem/MaterialList.vue'),
        meta: { title: '物料列表' }
      },
      {
        path: '/MaterialSystem/MaterialPurchaseList',
        name: 'MaterialPurchaseList',
        component: () => import('../views/adminBackend/SupplyChainSystem/MaterialSystem/MaterialPurchaseList.vue'),
        meta: { title: '物料采购' }
      },
      {
        path: '/MaterialSystem/MaterialInList',
        name: 'MaterialInList',
        component: () => import('../views/adminBackend/SupplyChainSystem/MaterialSystem/MaterialInList.vue'),
        meta: { title: '物料入库' }
      },
      {
        path: '/MaterialSystem/MaterialOutList',
        name: 'MaterialOutList',
        component: () => import('../views/adminBackend/SupplyChainSystem/MaterialSystem/MaterialOutList.vue'),
        meta: { title: '物料出库' }
      },
      // 生产管理
      {
        path: '/ProductionSystem/BomList',
        name: 'BomList',
        component: () => import('../views/adminBackend/ProductionSystem/BomList.vue'),
        meta: { title: 'BOM清单' }
      },
      {
        path: '/ProductionSystem/ProductionPlanList',
        name: 'ProductionPlanList',
        component: () => import('../views/adminBackend/ProductionSystem/ProductionPlanList.vue'),
        meta: { title: '生产计划' }
      },
      {
        path: '/ProductionSystem/ProductionProductList',
        name: 'ProductionProductList',
        component: () => import('../views/adminBackend/ProductionSystem/ProductionProductList.vue'),
        meta: { title: '生产产品' }
      },
      {
        path: '/ProductionSystem/RawMaterialList',
        name: 'ProductionRawMaterialList',
        component: () => import('../views/adminBackend/ProductionSystem/RawMaterialList.vue'),
        meta: { title: '原料需求' }
      },
      {
        path: '/ProductionSystem/CustomProductionList',
        name: 'CustomProductionList',
        component: () => import('../views/adminBackend/ProductionSystem/CustomProductionList.vue'),
        meta: { title: '定制生产' }
      },
      // 网站管理
      {
        path: '/Website/WebsiteList',
        name: 'WebsiteList',
        component: () => import('../views/adminBackend/Website/WebsiteList.vue'),
        meta: { title: '网站列表' }
      },
      {
        path: '/Website/WebPageList',
        name: 'WebPageList',
        component: () => import('../views/adminBackend/Website/WebPageList.vue'),
        meta: { title: '页面管理' }
      },
      {
        path: '/Website/ModuleContentList',
        name: 'ModuleContentList',
        component: () => import('../views/adminBackend/Website/ModuleContentList.vue'),
        meta: { title: '素材管理' }
      },
      {
        path: '/Website/ArticleList/:articleType',
        name: 'ArticleList',
        component: () => import('../views/adminBackend/Website/ArticleManager.vue'),
        meta: { title: '文章管理' }
      },
      // 财务管理
      {
        path: '/FinanceSystem/FinanceDashboard',
        name: 'FinanceDashboard',
        component: () => import('../views/adminBackend/Dashboard/FinanceDashboard.vue'),
        meta: { title: '财务看板' }
      },
      {
        path: '/FinanceSystem/AccountList',
        name: 'AccountList',
        component: () => import('../views/adminBackend/FinanceSystem/AccountList.vue'),
        meta: { title: '账户管理' }
      },
      {
        path: '/FinanceSystem/DailyAccountList',
        name: 'DailyAccountList',
        component: () => import('../views/adminBackend/FinanceSystem/DailyAccountList.vue'),
        meta: { title: '流水记账' }
      }
    ]
  }
]

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 导出路由，供main.js使用
export default router
